import i18n from "@/i18n";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { OperationRequestData } from "../../data/operationRequestData";
import { DeclarationPropertyValueData } from "../../data/declarationPropertyValueData";
import { DeclarationData } from "../../data/declarationData";
import { TemplateData } from "../../data/templateData";
import { ContractModel } from "../contracts/contractModel";
import { parseAmericanDate } from "../../utilities/parseHelper";
import { ContractsModel } from "../contracts/contractsModel";
import { TemplateModel } from "./TemplateModel";
import { getAmericanDate } from "../../utilities/parseHelper";
import { dateFormat } from "../../utilities/parseHelper";

/** Модель шаблона операции */
export class TemplateCreateModel extends TemplateModel {
  public OperationId: number = 0;

  public TemplateId: number = 0;

  constructor(
    declaration: DeclarationData,
    template: OperationRequestData,
    tempData: TemplateData,
    contracts: ContractsModel | null = null
  ) {
    super(declaration, template, tempData, contracts);
  }

  public setOperationId(id: number) {
    if (id) {
      this.OperationId = id;
    }
  }

  /**
   * Создание запроса операции.
   */
  public createOperationRequest(): OperationRequestData {
    const ord = new OperationRequestData();
    //ord.SetProperty("templateId", td.Id.ToString(), DeclarationPropertiesTypes.Int);
    //ord.SetProperty("templateName", td.Name.ToString(), DeclarationPropertiesTypes.String);
    super.prepareDataForRequest();
    ord.setProperty(
      "templateName",
      this.Name,
      DeclarationPropertiesTypes.String
    );
    ord.setProperty(
      "period",
      this.EditTemplateCopy.Period.toString(),
      DeclarationPropertiesTypes.Int
    );
    ord.setProperty(
      "dayNumber",
      this.EditTemplateCopy.DayNumber.toString(),
      DeclarationPropertiesTypes.Int
    );
    ord.setProperty(
      "nextDate",
      this.EditTemplateCopy.NextDate && this.EditTemplateCopy.Period > 0
        ? getAmericanDate(dateFormat(this.EditTemplateCopy.NextDate, "date"))
        : "",
      DeclarationPropertiesTypes.DateTime
    );

    ord.templateId = this.TemplateId;

    ord.operationId = this.OperationId;

    return ord;
  }

  /**
   * Заполнение операции данными из ответа запроса.
   * @param ord Данные запроса.
   * @param bAssign Признак assign.
   */
  public setOperationFromRequest(...args: any[]): void {
    console.log("No implemetation");
    this.TemplateId = args[0].operationId;
  }
}
